import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Form, Button, Message } from "semantic-ui-react";
import InlineError from "../messages/InlineError";
import settings from "../../settings";
import ReaptchaForm from "./ReaptchaForm";
import { resetAppErrorMessage } from "../../actions/appMessage";

class ResetForm extends React.Component {
  state = {
    data: {
      password: "",
      username: "",
      termscheck: "",
      appname: settings.appName,
      varified: false,
    },
    loading: false,
    errors: {},
  };

  onChange = (e) =>
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value },
    });

  onTermsChange = (e) =>
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.checked },
    });

  onSubmit = (e) => {
    e.preventDefault();
    const errors = this.validate(this.state.data);
    this.setState({ errors });
    if (Object.keys(errors).length === 0) {
      this.setState({ loading: true });
      this.props
        .submit(this.state.data)
        .then(() => {
          this.props.resetAppErrorMessage();
          this.setState({ loading: false });
        })
        .catch((err) => {
          this.setState({ errors: err.response.data.errors, loading: false });
        });
    }
  };

  onCaptchaResponse = (response) => {
    if (response && response.data && response.data.Status === "success")
      this.setState({ varified: true });
  };

  validate = (data) => {
    const errors = {};
    if (!data.username) errors.username = "User ID cannot be blank";
    if(data.username.indexOf(" ") !== -1) errors.username = "User ID cannot contain spaces";
    if (!data.username) errors.username = "Username cannot be blank";
    if(data.username.length < 6) errors.username = "Username must be at least 6 characters long";
    if(data.username.indexOf(".") !== -1 || data.username.indexOf("@") !== -1) errors.username = "Please enter a valid User ID";
    return errors;
  };

  render() {
    const { data, errors, loading } = this.state;
    return (
      <Form onSubmit={this.onSubmit} loading={loading}>
        {(errors.global ||
          this.props.resetError ||
          this.props.errorMessage) && (
          <Message negative>
            <Message.Header>Something went wrong</Message.Header>
            <p>
              {errors.global ||
                this.props.resetError ||
                this.props.errorMessage}
            </p>
          </Message>
        )}
        <Form.Field>
          <p>
            Please enter the information below to start the process of resetting
            your password.
          </p>
        </Form.Field>
        <Form.Field error={!!errors.username}>
          <label className="font-family" htmlFor="username">
            User ID:
          </label>
          <input
            type="text"
            id="username"
            name="username"
            tabIndex="a"
            autoComplete="username"
            placeholder="Enter your user ID"
            value={data.username}
            onChange={this.onChange}
          />
          {errors.username && <InlineError text={errors.username} />}
        </Form.Field>
        <Form.Field>
          <ReaptchaForm
            sitekey="reset"
            onCaptchaResponse={this.onCaptchaResponse}
          />
        </Form.Field>
        <Button primary disabled={!this.state.varified}>
          Reset
        </Button>
      </Form>
    );
  }
}

ResetForm.propTypes = {
  submit: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    errorMessage: state.appMessage && state.appMessage.errorMessage,
  };
}

export default connect(mapStateToProps, { resetAppErrorMessage })(ResetForm);



// WEBPACK FOOTER //
// ./src/components/forms/ResetForm.js